<template>
  <div
    class="transition-outline group relative box-border cursor-pointer rounded-md bg-gray-600 px-[22px] pb-1.5 pt-2.5 font-inter text-xs font-medium capitalize leading-6 outline outline-2 outline-offset-[-2px] outline-transparent transition duration-300 hover:bg-gray-800 hover:outline-accent-1"
    :class="{ '!cursor-not-allowed !bg-gray-500 !outline-none': disabled }"
    @click="showNotification"
  >
    <div>
      <div
        v-if="beta && disabledBadge === ''"
        class="text-uppercase absolute right-2 top-2 rounded-sm bg-accent-3 px-1 py-0.5 text-[8.5px] leading-3 text-gray-10 dark:text-gray-900"
      >
        BETA
      </div>
      <div
        v-if="disabledBadge"
        class="text-uppercase absolute right-2 top-2 rounded-sm bg-accent-3 px-1 py-0.5 text-[8.5px] leading-3 text-gray-10 dark:text-gray-900"
      >
        {{ disabledBadge }}
      </div>

      <div
        v-if="!$slots.icon"
        class="flex h-5 items-center justify-center text-gray-100 transition duration-300"
        :class="{
          'group-hover:text-gray-50': !disabled,
          'text-gray-200': disabled,
        }"
      >
        <icons-wrapper :icon="type"></icons-wrapper>
      </div>

      <div
        v-else
        class="content-box-svg flex h-5 items-center justify-center text-gray-100 transition duration-300"
        :class="{
          'group-hover:text-gray-50': !disabled,
          'text-gray-200': disabled,
        }"
      >
        <slot name="icon"></slot>
      </div>
      <div
        v-tooltip="{
          content: title.length > MAX_LENGTH ? title : '',
        }"
        class="mt-0.5 whitespace-nowrap text-center text-gray-200 transition duration-300"
        :class="{
          'group-hover:text-gray-10': !disabled,
        }"
      >
        {{ truncatedTitle }}
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import IconsWrapper from "./IconsWrapper.vue";
  import { useI18n } from "vue-i18n";
  import { computed } from "vue";
  import { useNotificationsStore } from "@/stores/notifications";

  const { t } = useI18n();
  const notificationsStore = useNotificationsStore();

  const MAX_LENGTH = 9;

  const props = defineProps({
    type: {
      type: String,
      default: "text",
    },
    title: {
      type: String,
      required: true,
    },
    disableNotification: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    beta: {
      type: Boolean,
      default: false,
    },
    disabledBadge: {
      type: String,
      default: "",
    },
  });

  const truncatedTitle = computed(() => {
    if (!props.title) return "";
    return props.title.length > MAX_LENGTH
      ? props.title.substring(0, MAX_LENGTH - 1) + "..."
      : props.title;
  });

  function showNotification() {
    if (!props.disableNotification) {
      notificationsStore.createNotification({
        text: t("blocks.drag_content"),
        type: "info",
      });
    }
  }
</script>
<style lang="scss">
  .transition-outline {
    transition-property: all !important;
  }
  .content-box-svg {
    svg {
      width: auto !important;
      height: 100% !important;
    }
  }
</style>
